import { Card, CardContent, Tab, Tabs } from '@mui/material'
import { TabPanel } from '@src/components'
import { FraudFlagDto } from '@src/data/api/fraud/fraud-api'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FraudFlagsGrid } from './FraudFlagsGrid'

interface FraudFlagsContentProps {
  fraudFlags: FraudFlagDto[] | null | undefined,
  indicatorType: string,
  financingProgramId: string,
  creditApplicationId: string,
  activeFlags: FraudFlagDto[]
}

const FraudFlagsContent: React.FC<FraudFlagsContentProps> = ({ fraudFlags, indicatorType, financingProgramId, creditApplicationId, activeFlags }) => {
  const { t } = useTranslation()
  const [tabValue, setTabValue] = useState(0)
  const flagsByCategory = useMemo(() => {
    if (!fraudFlags) return {}

    const grouped: Record<string, typeof fraudFlags> = {}

    fraudFlags.forEach((flag) => {
      if (!grouped[flag.category]) {
        grouped[flag.category] = []
      }
      grouped[flag.category].push(flag)
    })

    // Hide temporarily "Collection" category
    const { Collection, ...filtered } = grouped

    return filtered
  }, [fraudFlags])

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label={t('fraudFlags.tabs.activeOnly')} />
          <Tab label={t('fraudFlags.tabs.addFlags')} />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <FraudFlagsGrid
            indicatorType={indicatorType}
            flagsByCategory={{ [t('fraudFlags.activeFlags_label')]: activeFlags }}
            financingProgramId={financingProgramId}
            creditApplicationId={creditApplicationId || ''}
            mode="active"
            expandAllByDefault={activeFlags.length > 0}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <FraudFlagsGrid
            indicatorType={indicatorType}
            flagsByCategory={flagsByCategory}
            financingProgramId={financingProgramId}
            creditApplicationId={creditApplicationId || ''}
            mode="category"
          />
        </TabPanel>
      </CardContent>
    </Card>
  )
}

export default FraudFlagsContent